import React, { useRef } from 'react';

import { iconsSources } from '../../helpers/icons';
import { useScrollText } from '../../hooks/useScrollText';

import styles from './Message.module.css';
import cn from 'classnames';
import { clearTextFromTags, hideNumber } from '../../helpers/titreHelper';

const Message = ({
  className,
  message,
  titrTag,
  setDelay,
  messagesWrapper,
  currentMessageRef,
  authorFontSize,
  msgFontSize,
}) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const isCurrent = currentMessageRef?.message?.id === message?.id;

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    messagesWrapper,
    isCurrent
  );

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };
  return (
    <div className={cn(styles.wrapper, className)}>
      {message && (
        <>
          <div className={styles.top}>
            <div className={styles.avatar}>
              <img
                src={
                  (message?.image !== '1' && message?.image) ||
                  iconsSources[message?.channel]
                }
                alt={message?.author}
                onError={errorHandler}
              />
            </div>
            <div
              className={cn(
                styles.name,
                titrTag === 'F2' ? styles.favorite : ''
              )}>
              <div style={{ fontSize: `${authorFontSize}rem` }}>
                {message?.author || hideNumber(message?.senderNumber)}
              </div>
            </div>
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.content}>
              <div
                className={styles.textWrapper}
                ref={contentContainerRef}
                style={{
                  maxHeight: `${9 * 1.4 * msgFontSize}rem`, // макс 9 строчек с высотой строки 140%
                }}>
                {message?.content && (
                  <div
                    className={styles.text}
                    ref={contentRef}
                    style={{
                      fontSize: `${msgFontSize}rem`,
                      lineHeight: `${1.4 * msgFontSize}rem`, // высота строки 140%
                    }}>
                    {clearTextFromTags(message.content)}
                  </div>
                )}
              </div>

              {message?.attachments &&
                message?.attachments[0] &&
                message.attachments[0].type === 'image' && (
                  <div className={styles.contentImg}>
                    <img
                      src={message?.attachments[0].url}
                      alt={message?.author || hideNumber(message?.senderNumber)}
                    />
                  </div>
                )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
